import type { FernieFaceState } from "~/components/fernie/fernieMarkRules";

import { useMemo } from "react";

import { deriveFernieFaceState, type FernieFaceActivity } from "~/helpers/aiChat/fernieFaceState";

const useFernieFaceState = (activity: FernieFaceActivity): FernieFaceState =>
	useMemo(
		() => deriveFernieFaceState(activity),
		[activity.isComposing, activity.isRunActive, activity.outcome, activity.steps]
	);

export default useFernieFaceState;
